var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignal0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "#292829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 38 2 L 38 3 L 38 48 L 48 48 L 48 2 L 38 2 z M 40 4 L 46 4 L 46 46 L 40 46 L 40 4 z M 26 13 L 26 14 L 26 48 L 36 48 L 36 13 L 26 13 z M 28 15 L 34 15 L 34 46 L 28 46 L 28 15 z M 14 24 L 14 25 L 14 48 L 24 48 L 24 24 L 14 24 z M 16 26 L 22 26 L 22 46 L 16 46 L 16 26 z M 2 35 L 2 36 L 2 48 L 12 48 L 12 35 L 2 35 z M 4 37 L 10 37 L 10 46 L 4 46 L 4 37 z",
    fill: "#292829"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal0);
export default __webpack_public_path__ + "static/media/signal0.907f39efa4533c0538033e397b3cac23.svg";
export { ForwardRef as ReactComponent };